/**
 * SNS Platform constants
 *
 * Purpose:
 * - Shared platform keys used across SNS detection/render flows.
 */

const SNSPlatform = Object.freeze({
    YOUTUBE: "youtube",
    FACEBOOK: "facebook",
    INSTAGRAM: "instagram",
    X: "x",
    TIKTOK: "tiktok",
});

export { SNSPlatform };
